const drawerWidth = 319;

const styles = theme => {
  return {
    '@global': {
      'html, body, #app': {
        height: '100%'
      },
      body: {
        fontFamily: 'Roboto'
      },
      'input[type="checkbox"]': {
        height: '18px',
        width: '18px',
        verticalAlign: 'middle'
      }
      // TODO: scrollbar styles from source/html/index.html
    },
    root: {
      display: 'flex',
      height: '100%'
    },
    appBar: {
      zIndex: [theme.zIndex.drawer + 1, '!important'],
      // transition: theme.transitions.create(['width', 'margin'], {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.leavingScreen
      // }),
      // paddingRight: '0.25em',
      backgroundColor: [theme.palette.common.white, '!important'],
      color: [theme.palette.common.black, '!important']
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      // transition: theme.transitions.create(['width', 'margin'], {
      //   easing: theme.transitions.easing.sharp,
      //   duration: theme.transitions.duration.enteringScreen
      // })
    },
    menuButton: {
      marginLeft: 12,
      marginRight: ['36px', '!important']
    },
    hide: {
      display: ['none', '!important']
    },
    drawerPaper: {
      overflowX: 'hidden',
      overflowY: 'auto',
      height: '100%',
      position: ['relative', '!important'],
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
      backgroundColor: [theme.palette.primary.main, '!important'],
      color: [theme.palette.common.white, '!important']
    },
    drawerPaperClose: {
      zIndex: [theme.zIndex.drawer - 1, '!important'],
      overflowX: 'hidden',
      visibility: ['visible', '!important'],
      transform: ['none', '!important'],
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      width: '72px',
      [theme.breakpoints.up('sm')]: {
        width: '72px'
      }
    },
    drawerPaperOpen: {
      zIndex: [theme.zIndex.drawer +10, '!important']
    },
    toolbar: {
      display: ['flex', '!important'],
      alignItems: ['center', '!important'],
      justifyContent: ['flex-end', '!important'],
      padding: ['0 8px', '!important'],
      ...theme.mixins.toolbar
    },
    content: {
      flexGrow: 1,
      padding: [theme.spacing(3), '!important'],
      height: '100%',
      overflowY: 'hidden'
    },
    drawerBar: {
      backgroundColor: theme.palette.common.white
    },
    blackColor: {
      color: [theme.palette.common.black, '!important']
    },
    whiteColor: {
      color: [theme.palette.common.white, '!important']
    },
    navigationIconFA: {
      width: '1.5em',
      height: '1em',
      fontSize: '16px',
      textAlign: 'center',
      color: [theme.palette.common.white, '!important']
    },
    organizationSelect: {
      marginLeft: 'auto',
      marginRight: '2em'
    }
  };
};

export default styles;
